import React from 'react';
import {Checkbox as AntCheckbox} from 'antd';
import './styles.less';
const Checkbox = (props) => {
    return (
        <AntCheckbox {...props} className={`hms-checkbox ${props.className}`}>{props.children}</AntCheckbox>
    )
}
export default Checkbox;